<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-title">
                            为贯彻落实“成都人才新政12条”激励产业人才相关政策举措，对符合条件的市实体经济新经济领域人才给予奖励。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-three-24">
                <img src="../assets/imgs/22/part-2-title.png" class="part-two-title-img" />
                <div class="part-title part-four-title">
                    自2017年7月后新进入我市工作满一年及以上的人才，且工作所在单位属于实体经济和新经济领域（不包括国有企业人才、企业化管理的事业单位引进从业的人才、企业内部调整调动进入的人才）。
                </div>
                <div class="part-three-content">
                    <p class="part-three-content-item">
                        实体经济是指农业、工业、交通通信业、商业服务业等具有基础性、支撑性、稳定性、引领性的实体经济领域，不包括金融业、房地产业、体育经济、博彩业、收藏业等虚拟经济。
                    </p>
                    <p class="part-three-content-item">
                        新经济是指新的经济形态，以高技术产业为支柱，以智力资源为主要依托的智慧经济形态，主要包括数字经济、智能经济、绿色经济、创意经济、流量经济、共享经济等六大经济形态。
                    </p>
                </div>
            </div>
            <div class="part-three-extra">
                <img src="../assets/imgs/22/part-3-title.png" class="part-two-title-img" />
                <div class="main-content" style="margin-top: 0.1rem">
                    <div class="part-four-items">
                        原则上按申报人上一年度缴纳个人所得税后年收入不超过5%进行奖励。年收入为任职受雇在某一单位缴纳个人所得税后年各项个人所得（包括但不限于工资、薪金、奖励、分红等）的总和。
                    </div>
                </div>
                <div style="
                            color: #3d5aa3ff;
                            font-size: 0.26rem;
                            text-align: left;
                            line-height: 1.5;
                            margin-top: 0.25rem;
                        ">
                    注：在政策有效期内，每个人只享受1次。本政策与各区（市）县同类政策不重复享受。
                </div>
            </div>
            <div class="part-three-24">
                <img src="../assets/imgs/18/part-2-title.png" class="part-two-title-img" />
                <div class="part-title part-four-title">
                    申报人及所在单位应同时具备以下基本条件：
                </div>
                <div class="part-three-content">
                    <p class="part-three-content-item">
                        （1）与所在单位签订了3年以上的劳动合同；
                    </p>
                    <p class="part-three-content-item">
                        （2）所在单位在我市注册且税收解缴关系在我市的企业；
                    </p>
                    <p class="part-three-content-item">
                        （3）所在单位属本办法下的实体经济领域或新经济领域；
                    </p>
                    <p class="part-three-content-item">
                        （4）上一年度缴纳个人所得税后年收入50万元以上
                        （民营企业人才上一年度缴纳个人所得税后年
                        收入40万元以上）；
                    </p>
                    <p class="part-three-content-item">
                        （5）申报人已足额缴纳了个人所得税；
                    </p>
                    <p class="part-three-content-item">
                        （6）申报人没有受到刑事处罚，或刑事处罚已经执行完毕。
                    </p>
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/18/part-5-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        <div class="title-bg">
                            年度集中申报 （以2022年为例）
                        </div>
                        <div class="part-four-content1">
                            <p>
                                （一）该年度申报通知发放后，申报人向所在区（市）县工业和信息化主管部门提交申报材料，应包含以下材料：
                            </p>
                            <p>
                                1.《成都市实体经济新经济领域人才奖励申报表》；
                            </p>
                            <p>
                                2.所在单位提供支付申报人工资薪金、奖金分红等的证明；
                            </p>
                            <p>3.申报人个人所得税完税证明；</p>
                            <p>4.申报人任职文件复印件（加盖所在单位鲜章）；</p>
                            <p>
                                5.所在单位的法人证书（正、副本）或多证合一证（正、副本）复印件（加盖所在单位鲜章）；
                            </p>
                            <p>
                                6.申报人与所在单位签订的劳动合同复印件（加盖所在单位鲜章）。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg2">区（市）县初审推荐</div>
                        <div class="part-four-content1">
                            <p>
                                各区（市）县工业和信息化主管部门会同财政部门牵头负责，共同组织申报、资料初审等工作，报送至市经信局。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61881622">028-61881622</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市经济和信息化局人事处
                    </div>
                </div>
            </div>
            <div class="part-five">
                <div style="position: relative">
                    <img style="width: 5.04rem; height: 1.94rem" src="../assets/imgs/18/code-1.png" alt="" /><img style="
                                width: 1.94rem;
                                height: 1.94rem;
                                position: absolute;
                                top: 0;
                                left: 0;
                            " src="../assets/imgs/18/code-1-1.png" alt="" />
                </div>
            </div>
            <!-- <div class="bottom-info" style="margin-top: 0.25rem">
                责任单位：成都市经济和信息化局人事处
            </div>
            <div class="bottom-info" style="margin-top:0.15rem">
                咨询电话：<a href="tel:028-61881622">028-61881622</a>
            </div> -->
            <!-- <bottom phone="028-61881622" unit="成都市经济和信息化局人事处"></bottom> -->
        </div>
        <call phone="028-61881622"></call>
    </div>
</template>

<script>
// import bottom from '../components/bottom.vue'
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part3: [
                {
                    id: 1,
                    title: require("../assets/imgs/craft/part3-1.png"),
                    content: "可获一次性2万元奖励",
                    boxHeight: "height:1.45rem",
                },
                {
                    id: 2,
                    title: require("../assets/imgs/craft/part3-2.png"),
                    content: "按规定享受教育优待政策",
                    boxHeight: "height:1.42rem",
                },
                {
                    id: 3,
                    title: require("../assets/imgs/craft/part3-3.png"),
                    content: "凭卡享受医疗、交通、保险、文体娱乐等服务保障",
                    boxHeight: "height:1.42rem",
                },
                {
                    id: 4,
                    title: require("../assets/imgs/craft/part3-4.png"),
                    content:
                        "还可享受人才落户、便捷就医、交通出行、身心健康、保险保障、学习交流等相关政策支持",
                    boxHeight: "height:1.9rem;margin-bottom:0",
                    text: "text-align: left;",
                },
            ],
            part4: [
                {
                    id: 1,
                    title: "title-bg",
                    label: "推荐申报",
                    content1: {
                        title: "单位推荐：",
                        text: `年度申报通知发放后，符合条件的申请人向单位工商注册地的区（市）县人社部门递交以下以下申报材料：
                                1.属自主创业
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                                （2）本人所创办企业的营业执照复印件，完税证明的原件及复印件；
                                （3）身份证、学历学位证书、学历学位鉴定证明、社保卡（带银行金融功能）或银行账户等材料的原件及复印件；`,
                    },
                    content2: {
                        title: "个人申报：",
                        text: `2.属在企业从事相关创新工作
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                                （2）企业营业执照复印件；
                                （3）本人从事相关创新工作的证明资料；
                                （4）本人身份证、学历学位证书、学历学位鉴定证明（教育部留学服务中心认证的《国外学历学位认证书》、《港澳台学历学位认证书》或四川省人社厅专家服务中心认证的《四川省海外留学人员证书》）、社保卡（带银行金融功能）或银行账户、劳动合同（1年及以上）、社保缴纳证明（6个月及以上）等材料的原件及复印件。`,
                    },
                },
                {
                    id: 2,
                    label: "资格审核",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "所在区（市）县总工会对申报对象进行初审、择优推荐至市总工会。市总工会对单位申报人员进行资格复核",
                    },
                    content2: "",
                    boxHeight: "height:1.79rem",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    p {
        line-height: 1.5;
    }

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 6.7rem;
        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/18/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-content {
            margin-top: 1.2rem;
            width: 100%;
            padding: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;
        }
    }

    .part-three-24 {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.5rem 0.25rem 0 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;
            font-weight: 500;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .part-three-content {
            text-align: left;
            color: #4e4e4eff;
            font-size: 0.26rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.25rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.52rem;
            margin-top: 0.25rem;

            .part-three-content-tittle {
                font-size: 0.34rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
            }

            .part-three-content-item {
                // position: relative;
                // padding-left: 0.2rem;
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }

        .out-link {
            position: absolute;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #3d5aa3;
            bottom: 0.45rem;
            left: 0.25rem;
            text-align: center;
            text-decoration: none;
        }
    }

    .part-three-extra {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .main-content {
            margin-top: 0.8rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;
            position: relative;
            // margin-bottom: 0.8rem;

            .part-four-title {
                text-align: left;
                position: absolute;
                top: 0;
                left: 50%;
                font-size: 0.32rem;
                background-color: #739bfeff;
                color: #fff;
                border-radius: 20px;
                padding: 0.18rem 0.2rem;
                transform: translate(-50%, -50%);
                white-space: nowrap;
            }

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.2rem 0.25rem 0 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.25rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                    white-space: nowrap;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/craft/part4-5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/craft/part4-6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content1 {
                    margin-bottom: 0.2rem;

                    p {
                        margin: 0.01rem;
                    }
                }
            }
        }
    }

    .part-five {
        margin: auto;
        margin-top: 0.25rem;
        width: 6.86rem;
        box-sizing: border-box;
        border-radius: 13px;
        margin-bottom: 0.32rem;
        background-color: #fff;
        padding: 0.35rem;
        text-align: left;

        img {
            width: 100%;
        }
    }

    .bottom-info {
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;
    }
}
</style>
